var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-mini message-section"},[_c('span',[_vm._v(" To update the current installation address, please call us at "+_vm._s(_vm.supportPhone))])])}
var staticRenderFns = []

export { render, staticRenderFns }